export class Tag {
  constructor(public name: string, public target: string) {
  }
}
